import React from "react";

import {
  faCheck,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";

import { FaIcon } from "components/AgGridButtonIcon/agGridButtonIcon";
import Clickable from "components/Button/Clickable";

import { openEditConsignmentModal } from "lib/navigation";

import history from "appHistory";

export function NVDRecRenderer({ value, data }) {
  if (!data) {
    return null;
  }

  // Handle salelots and consignments aggrids
  const { consignment = data } = data;
  const hasNoExceptions = value !== false && !consignment.hasNVDExceptions;

  return (
    <Clickable
      onClick={() => {
        history.push(`attachments?consignment=${consignment.id}`);
      }}
    >
      <FaIcon
        icon={hasNoExceptions ? faCheck : faExclamationCircle}
        color={hasNoExceptions ? "success" : "warning"}
      />
    </Clickable>
  );
}

export function NVDRenderer(props) {
  if (!props.data) {
    return null;
  }
  const { value } = props;
  if (value) {
    return value;
  } else {
    return <FaIcon icon={faExclamationCircle} color="warning" />;
  }
}

export function NVDIDRenderer(props) {
  const { value, data } = props;

  if (!data) {
    return null;
  }

  let consignmentId = null;

  if (data.consignment) {
    consignmentId = data.consignment.id;
  } else {
    consignmentId = data.id;
  }

  function onClickEdit() {
    if (consignmentId) {
      openEditConsignmentModal(consignmentId, undefined, true);
    }
  }

  if (value) {
    return value;
  } else {
    return (
      <FaIcon
        icon={faExclamationCircle}
        color="warning"
        onClick={onClickEdit}
        style={{ cursor: "pointer" }}
      />
    );
  }
}
